import { Model } from "./model";

export class Entry extends Model {
    id: number;
    user_id: number;
    challenge_id: number;
    filename: string;
    comments?: string;
    validated: number;
    points: number;
    created: string;
    entry_id?: number;
    entry_filename?: string;
    entry_comments?: string;
    entry_status?: number;
    entry_points?: number;
    entry_created?: string;
}


// WEBPACK FOOTER //
// ./src/models/entry.model.ts